import * as React from 'react';

export const useDataExportController = () => {
  const [exportDataOpened, setExportDataOpenedState] = React.useState(false);

  const openExportData = React.useCallback(() => {
    setExportDataOpenedState(true);
  }, []);

  const closeExportData = React.useCallback(() => {
    setExportDataOpenedState(false);
  }, []);

  return {
    exportDataOpened,
    openExportData,
    closeExportData,
  };
};